// import external/vendor styles
import 'vuetify/dist/vuetify.min.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

import Vue from 'vue';
import Vuetify from 'vuetify';
import VueApollo from 'vue-apollo';
import VueWorker from 'vue-worker';
import Chart from 'chart.js';
import VueBrowserUpdate from 'vue-browserupdate';
import VTour from '@/components/tour/VTour';
import VStep from '@/components/tour/VStep';
import store from '@/store/store';
import App from '@/App';
import router from '@/router';
import { apolloProvider } from '@/apollo/apollo';
import { AppConfigPlugin } from '@/app.config';
import numFormat from '@/functions/numFormat';
import * as appColors from '@/functions/appColors';

// install Vuetify
Vue.use(Vuetify, {
    theme: {
        primary: String(appColors.primary),
        secondary: String(appColors.secondary),
        accent: String(appColors.accent),
    },
});

const VueTour = {
    install(Vobj) {
        Vobj.component(VTour.name, VTour);
        Vobj.component(VStep.name, VStep);
        Vobj.prototype.$tours = {};
    },
};

Vue.use(VueTour);

// Give charts white background for exporting into images
Chart.plugins.register({
    beforeDraw(chartInstance) {
        const ctx = chartInstance.chart.ctx;
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
    },
});

// install app.config plugin
Vue.use(AppConfigPlugin);

Vue.use(VueWorker);
Vue.use(VueApollo);

Vue.use(VueBrowserUpdate, {
    options: {
        required: { c: 49, f: 49 },
        // chrome, firefox <49 gets notified (both about 2 years old)
        // defaults for others are pretty sane
        reminder: 24, // remind again in 24h after being dismissed.
        no_permanent_hide: true, // don't let them permanently hide this - upgrade your damn browser!
    },
    // test: true, // uncomment this if you want to see what it looks like.
});
// add number formatting filter
Vue.filter('numFormat', numFormat);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    apolloProvider,
    render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js